import React, { useState, useRef, useEffect } from 'react'
import Navbar from '../../Navbar';
import { Box, Container, Grid, Typography, Tabs, Tab, Divider } from '@mui/material';
import {
  Storefront as StoreIcon,
} from '@mui/icons-material';
import { useTheme } from 'styled-components';
import { useFechas } from '../pedidosEnvasado/context/FechaContext';
import ResumenGeneral from './Conciliacion/ResumenGeneral';
import FiltrosGeneral from './filtros/FiltrosGeneral';
import AlmanaqueAcreditaciones from './acreditaciones/AlmanaqueAcreditaciones';

function ResumenCuentaCorriente() {
  const theme = useTheme();
  const { desde, hasta } = useFechas();
  const [loading, setLoading] = useState(false);
  const [filtrosActivos, setFiltrosActivos] = useState(null);
  const [triggerConciliacion, setTriggerConciliacion] = useState(0);
  
  // Estado para el tab seleccionado
  const [tabValue, setTabValue] = useState(0); // 0: Hipergas, 1: Natural Gas

  // Estado para guardar los datos de conciliación
  const [conciliacionData, setConciliacionData] = useState(null);
  const [cargandoConciliacion, setCargandoConciliacion] = useState(false);

  // Referencia al componente ResumenGeneral
  const resumenGeneralRef = useRef();

  // Efecto para actualizar los datos cuando cambia el trigger
  useEffect(() => {
    // Función para obtener los datos del componente hijo
    const obtenerDatos = () => {
      if (resumenGeneralRef.current) {
        const data = resumenGeneralRef.current.getConciliacion();
        const cargando = resumenGeneralRef.current.getCargando();
        
        setConciliacionData(data);
        setCargandoConciliacion(cargando);
      }
    };

    // Obtener datos inmediatamente
    obtenerDatos();

    // Configurar un intervalo para verificar cambios (opcional)
    // Esto es útil si el componente hijo actualiza los datos asíncronamente
    const intervalId = setInterval(() => {
      if (resumenGeneralRef.current) {
        const data = resumenGeneralRef.current.getConciliacion();
        const cargando = resumenGeneralRef.current.getCargando();
        
        // Solo actualizar si hay cambios
        if (data !== conciliacionData || cargando !== cargandoConciliacion) {
          setConciliacionData(data);
          setCargandoConciliacion(cargando);
        }
      }
    }, 500); // Revisar cada 500ms

    // Limpiar el intervalo cuando el componente se desmonte o cambie trigger
    return () => clearInterval(intervalId);
  }, [triggerConciliacion, tabValue]); // Re-ejecutar cuando cambie trigger o tab

  const handleFilter = async (filtros) => {
    setLoading(true);
    try {
      const filtrosProcesados = {
        desde: filtros.desde,
        hasta: filtros.hasta,
      };
      
      setFiltrosActivos(filtrosProcesados);
      setTriggerConciliacion(prev => prev + 1);

      await new Promise(resolve => setTimeout(resolve, 1000));
    } catch (error) {
      console.error('Error al filtrar:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClearFilters = () => {
    setFiltrosActivos(null);
    setTriggerConciliacion(0);
    setConciliacionData(null); // Limpiar los datos
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setConciliacionData(null); // Limpiar datos mientras carga
    setTriggerConciliacion(prev => prev + 1);
  };

  // Obtener el valor de empresa según el tab seleccionado
  const getEmpresaValue = () => {
    return tabValue === 0 ? 1 : 4; // Hipergas = 1, Natural Gas = 4
  };

  return (
    <>
      <Navbar />
      
      <FiltrosGeneral 
        onFilter={handleFilter}
        onClear={handleClearFilters}
      />

      <Container maxWidth="xl" sx={{ mt: 1, mb: 1 }}>
        {/* Tabs principales */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label="Hipergas" />
            <Tab label="NaturalGas" />
          </Tabs>
        </Box>

        {/* Resumen General */}
        <Box mb={3}>
          <ResumenGeneral 
            ref={resumenGeneralRef}
            key={`conciliacion-${triggerConciliacion}-${tabValue}`}
            desde={filtrosActivos?.desde}
            hasta={filtrosActivos?.hasta}
            empresa={getEmpresaValue()}
            loading={loading}
            triggerRecarga={triggerConciliacion}
          />
        </Box>

        {/* Almanaque de Acreditaciones - Debajo de ResumenGeneral */}
        {conciliacionData && !cargandoConciliacion && !loading && (
          <>
            <Divider sx={{ my: 3 }} />
            <Box sx={{ mt: 2 }}>
              <AlmanaqueAcreditaciones 
                conciliacion={conciliacionData} 
                loading={cargandoConciliacion || loading}
              />
            </Box>
          </>
        )}

        {/* Mostrar mensaje si está cargando */}
        {(cargandoConciliacion || loading) && (
          <Box sx={{ mt: 2, textAlign: 'center', py: 4 }}>
            <Typography variant="body2" color="textSecondary">
              Cargando datos de acreditaciones...
            </Typography>
          </Box>
        )}

        {/* Mostrar mensaje si no hay datos */}
        {!conciliacionData && !cargandoConciliacion && !loading && filtrosActivos && (
          <Box sx={{ mt: 2, textAlign: 'center', py: 4 }}>
            <Typography variant="body2" color="textSecondary">
              No hay datos de acreditaciones disponibles
            </Typography>
          </Box>
        )}
      </Container>
    </>
  )
}

export default ResumenCuentaCorriente;